/**
 * API Auth Context
 *
 * Module-level token provider for API calls.
 * In auth mode, the token getter is set at app initialization.
 * In public mode, no token is attached to requests.
 */

type TokenGetter = () => Promise<string | null>

let tokenGetter: TokenGetter | null = null

/**
 * Set the token getter function.
 * This should be called once at app initialization when in auth mode.
 */
export function setApiTokenGetter(getter: TokenGetter | null): void {
  tokenGetter = getter
}

/**
 * Get the current access token for API calls.
 * Returns null if no token getter is configured or if not authenticated.
 */
export async function getApiToken(): Promise<string | null> {
  if (!tokenGetter) {
    return null
  }
  return tokenGetter()
}

/**
 * Check if a token getter is configured.
 */
export function hasApiTokenGetter(): boolean {
  return tokenGetter !== null
}
